import { LoaderCircle } from 'lucide-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from '@/components/shell';
import { useCurrentUser } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import { Codes } from '@/routes/admin/codes';
import { CourseDetail } from '@/routes/admin/course-detail';
import { Courses } from '@/routes/admin/courses';
import { Curriculums } from '@/routes/admin/curriculums';
import { Dashboard } from '@/routes/admin/dashboard';
import { Demo } from '@/routes/admin/demo';
import { Email } from '@/routes/admin/email';
import { EmailDetail } from '@/routes/admin/email-detail';
import { GroupDetail } from '@/routes/admin/group-detail';
import { Groups } from '@/routes/admin/groups';
import { LocationAdd } from '@/routes/admin/location-add';
import { Locations } from '@/routes/admin/locations';
import { Portfolios } from '@/routes/admin/portfolios';
import { QuestionsAdd } from '@/routes/admin/question-add';
import { QuestionDetail } from '@/routes/admin/question-detail';
import { Settings } from '@/routes/admin/settings';
import { Superstats } from '@/routes/admin/superstats';
import { SurveysAdd } from '@/routes/admin/survey-add';
import { SurveyDetail } from '@/routes/admin/survey-detail';
import { Surveys } from '@/routes/admin/surveys';
import { TemplateAdd } from '@/routes/admin/template-add';
import { Templates } from '@/routes/admin/templates';
import { Users } from '@/routes/admin/users';

// Ports app/[brand]/admin/layout.tsx: the auth gate plus the admin route tree.
// Unauthenticated visitors are sent to the admin login; role/siteType gating of
// individual sections lives in the sidebar and in each section component.
export function AdminApp() {
  const { slug } = useBrand();
  const { user, loading } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <LoaderCircle className="text-primary size-12 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/${slug}/login/admin`} replace />;
  }

  return (
    <Shell>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="codes" element={<Codes />} />
        <Route path="courses" element={<Courses />} />
        <Route path="courses/:id" element={<CourseDetail />} />
        <Route path="curriculums" element={<Curriculums />} />
        <Route path="groups" element={<Groups />} />
        <Route path="groups/:id" element={<GroupDetail />} />
        <Route path="users" element={<Users />} />
        <Route path="locations" element={<Locations />} />
        <Route path="locations/add" element={<LocationAdd />} />
        <Route path="portfolios" element={<Portfolios />} />
        <Route path="settings" element={<Settings />} />
        <Route path="email" element={<Email />} />
        <Route path="email/:id" element={<EmailDetail />} />
        <Route path="templates" element={<Templates />} />
        <Route path="templates/add" element={<TemplateAdd />} />
        <Route path="surveys" element={<Surveys />} />
        <Route path="surveys/add" element={<SurveysAdd />} />
        <Route path="surveys/addquestion" element={<QuestionsAdd />} />
        <Route path="surveys/:id" element={<SurveyDetail />} />
        <Route path="surveys/question/:id" element={<QuestionDetail />} />
        <Route path="superstats" element={<Superstats />} />
        <Route path="demo" element={<Demo />} />
      </Routes>
    </Shell>
  );
}
